import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[otpEnhancer]'
})
export class OtpEnhancerDirective {
  @Input('otpEnhancer') otpInputRef: any; // pass your ng-otp-input reference

  // Handle paste
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    let pastedData = '';
    if (event.clipboardData) {
      pastedData = event.clipboardData.getData('text');
    }

    if (/^\d+$/.test(pastedData)) {
      const otpArray = pastedData.split('');
      if (this.otpInputRef && this.otpInputRef.setValue) {
        this.otpInputRef.setValue(otpArray);
      }
      event.preventDefault();
    }
  }

  // Handle backspace/delete
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (this.otpInputRef && this.otpInputRef.clearValue) {
        this.otpInputRef.clearValue(); // if library exposes clearValue
      } else {
        // fallback: manually clear inputs
        const inputs = (event.target as HTMLElement).querySelectorAll('input');
        inputs.forEach((input: any) => {
          if (document.activeElement === input) {
            input.value = '';
            input.focus();
          }
        });
      }
    }
  }
}
